exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.review-card[data-v-ea780124] {\n    height: 100%;\n}\n.star-color[data-v-ea780124] {\n  color: #FFBF00;\n}\n.verified-icon[data-v-ea780124] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n", ""]);

// exports
